import React from "react";
import { Row, Col, Table, FormGroup, Label, Input } from "reactstrap";
import { FormattedDate } from "react-intl";
import MediaQuery from "react-responsive";
import style from "../../../Modal/Invoice/style.module.scss";
import { CustomFormInput } from "../../../../utils/FormFields";
import { formattedNumber } from "../../../FormattedNumber/FormattedNumber";

const InvoicePayment = ({ payment }) => (
  <React.Fragment>
    <Row xs={14}>
      <Col xs={3}>
        <CustomFormInput label="Supplier">{payment.PaymentSupplierName}</CustomFormInput>
      </Col>
      <Col xs={2}>
        <CustomFormInput label="Currency">{payment.InvoicePaymentCurrencyISO}</CustomFormInput>
      </Col>
      <Col xs={2}>
        <CustomFormInput label="Payment Date">{payment.InvoicePaymentDate}</CustomFormInput>
      </Col>
      <Col xs={2}>
        <CustomFormInput label="RUT">{payment.PaymentSupplierRUT}</CustomFormInput>
      </Col>
      <Col xs={2}>
        <CustomFormInput label="Country">{payment.CountryName}</CustomFormInput>
      </Col>
    </Row>
    <Row xs={12}>
      <Col xs={3}>
        <CustomFormInput label="Bank">{payment.InvoicePaymentBankAccountName}</CustomFormInput>
      </Col>

      <Col xs={2}>
        <CustomFormInput label="Reference Number">{payment.InvoicePaymentReferenceNumber}</CustomFormInput>
      </Col>
      <Col xs={2}>
        <CustomFormInput label="Status">{payment.InvoicePaymentStatus}</CustomFormInput>
      </Col>
    </Row>
    <Details line={payment.InvoiceAssociated} />
    {console.log(payment)}
    <CustomFormInput label="Total payment amount">{payment.InvoicePaymentAmount}</CustomFormInput>
  </React.Fragment>
);

const Details = ({ line }) => (
  <React.Fragment>
    <Table>
      <thead>
        <tr>
          <th style={{ width: "15%" }}>Invoice Number</th>
          <th style={{ width: "15%" }}>Invoice Date</th>
          <th style={{ width: "15%" }}>Invoice Amount</th>
          <th style={{ width: "15%" }}>Unpaid Amount</th>
          <th style={{ width: "15%" }}>Payment Amount</th>
        </tr>
      </thead>
      <tbody>
        {line == undefined ? (
          <div></div>
        ) : line.length == 0 ? (
          <div></div>
        ) : (
          line.map((line, index) => (
            <tr>
              <td>
                <CustomFormInput label="">{line.SupplierInvoiceNumber}</CustomFormInput>
              </td>
              <td>
                <CustomFormInput label="">{line.SupplierInvoiceDate}</CustomFormInput>
              </td>
              <td>
                <CustomFormInput label="">{line.SupplierInvoiceTotal}</CustomFormInput>
              </td>
              <td>
                <CustomFormInput label="">{line.SupplierInvoiceUnpaidAmount}</CustomFormInput>
              </td>
              <td>
                <CustomFormInput label="">{line.InvoiceAssociatedPaymentAmount}</CustomFormInput>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </Table>
  </React.Fragment>
);

export default InvoicePayment;
